import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

const SESSION_ENDPOINT = '/auth/session';

@Component({
    selector: 'app-session-modal',
    templateUrl: './session-modal.component.html',
    styleUrls: ['./session-modal.component.css'],
    standalone: false
})
export class SessionModalComponent {
  displayedColumns: string[] = ['userAgent', 'ipAddress', 'createdAt', 'action'];
  sessionEndpoint: string;

  constructor(
    private http: HttpClient,
    public dialogRef: MatDialogRef<SessionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { sessions: any[] }
  ) {
    this.sessionEndpoint = environment.apiUrl + SESSION_ENDPOINT;
  }

  closeSession(sessionId: number): Observable<any> {
    return this.http.post<any>(this.sessionEndpoint + '/' + sessionId, {});
  }

  logoutSession(sessionId: number): void {
    this.closeSession(sessionId).subscribe(() => {
      this.dialogRef.close(sessionId);
    });
  }

  onNoClose(): void {
  }

  getBrowserName(userAgent: string): string {
    if (userAgent.includes('Chrome')) {
      return 'Chrome';
    } else if (userAgent.includes('Firefox')) {
      return 'Firefox';
    } else if (userAgent.includes('Safari')) {
      return 'Safari';
    } else if (userAgent.includes('Edge')) {
      return 'Microsoft Edge';
    } else if (userAgent.includes('MSIE') || userAgent.includes('Trident')) {
      return 'Internet Explorer';
    } else {
      return 'Desconocido';
    }
  }
}